var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-inline--fa fa-fw",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.8333V15C3 13.1591 4.49238 11.6667 6.33333 11.6667H9.66667C11.5076 11.6667 13 13.1591 13 15V15.8333M13 9.16667C14.3807 9.16667 15.5 8.04738 15.5 6.66667C15.5 5.28596 14.3807 4.16667 13 4.16667M18 15.8333V15C18 13.1591 16.5076 11.6667 14.6667 11.6667H14.25M10.5 6.66667C10.5 8.04738 9.38071 9.16667 8 9.16667C6.61929 9.16667 5.5 8.04738 5.5 6.66667C5.5 5.28596 6.61929 4.16667 8 4.16667C9.38071 4.16667 10.5 5.28596 10.5 6.66667Z",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9InN2Zy1pbmxpbmUtLWZhIGZhLWZ3IiB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zIDE1LjgzMzNWMTVDMyAxMy4xNTkxIDQuNDkyMzggMTEuNjY2NyA2LjMzMzMzIDExLjY2NjdIOS42NjY2N0MxMS41MDc2IDExLjY2NjcgMTMgMTMuMTU5MSAxMyAxNVYxNS44MzMzTTEzIDkuMTY2NjdDMTQuMzgwNyA5LjE2NjY3IDE1LjUgOC4wNDczOCAxNS41IDYuNjY2NjdDMTUuNSA1LjI4NTk2IDE0LjM4MDcgNC4xNjY2NyAxMyA0LjE2NjY3TTE4IDE1LjgzMzNWMTVDMTggMTMuMTU5MSAxNi41MDc2IDExLjY2NjcgMTQuNjY2NyAxMS42NjY3SDE0LjI1TTEwLjUgNi42NjY2N0MxMC41IDguMDQ3MzggOS4zODA3MSA5LjE2NjY3IDggOS4xNjY2N0M2LjYxOTI5IDkuMTY2NjcgNS41IDguMDQ3MzggNS41IDYuNjY2NjdDNS41IDUuMjg1OTYgNi42MTkyOSA0LjE2NjY3IDggNC4xNjY2N0M5LjM4MDcxIDQuMTY2NjcgMTAuNSA1LjI4NTk2IDEwLjUgNi42NjY2N1oiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utb3BhY2l0eT0iMC43IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };